import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { type ReactNode, useState } from 'react'

/**
 * Server state for the marketing site is public, cacheable and slow-moving
 * (categories, plans, CMS sections), so the defaults lean hard on the cache.
 * Nothing queries yet — the scaffold renders mock data — but the provider is
 * mounted so the first real hook needs no wiring.
 */
const createQueryClient = (): QueryClient =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000,
        gcTime: 30 * 60 * 1000,
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })

type QueryProviderProps = { children: ReactNode }

export const QueryProvider = ({ children }: QueryProviderProps) => {
  const [client] = useState(createQueryClient)

  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}
